export default __webpack_public_path__ + "static/media/HPT-USDT.ebe15631.svg";